export default __webpack_public_path__ + "static/media/eduOrange.b84be536.jpg";